<template>
<div class="row mt-5">
  <div class="col-xl-5" v-if="checkForPermission(add_customer_type_permission)">
    <customer-type-form button_text="Add Customer Type" @typeAction="addCustomerType"/>
  </div>
  <div class="col-xl-1"></div>
  <div class="col-xl-6">>
    <TableLoading v-if="institutionTypes.page === 0"/>
    <div v-else>
      <data-table :columns="columns" :rows="institutionTypes.objects" :has-pagination="false" @onSearch="searchFn">
        <template v-slot:actions="slotProps" v-if="checkForPermission(edit_customer_type_permission)">
          <b-button v-b-modal.edit-customer-type variant="success" size="sm" class="py-1 text-white" @click="selectCustomerType(slotProps.row)">
            Edit
          </b-button>
        </template>
      </data-table>
      <b-pagination
          v-model="currentPage"
          :total-rows="institutionTypes.total"
          :per-page="perPage"
          size="lg"
          align="center"
          class="mt-3"
      />
    </div>

    <b-modal
        id="edit-customer-type"
        centered
        size="lg"
        hide-footer
        hide-header
        title-class="font-18">
      <div class="p-2">
        <h3>Edit Customer Type</h3>
        <customer-type-form button_text="Edit Customer Type" :selected_type="selected_type" @typeAction="editCustomerType"/>
        <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-customer-type')">Close</b-button>
      </div>
    </b-modal>
  </div>
</div>
</template>

<script>
import CustomerTypeForm from "@/components/settings/customer-types-form";
import DataTable from "@/components/data-table";
import {ALL_CUSTOMER_TYPES} from "@/gql";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";
export default {
name: "customer-type-component",
  components: {TableLoading, DataTable, CustomerTypeForm},
  data(){
    return{
      selected_type: {},
      add_customer_type_permission: permissions.add_customer_type_permission,
      edit_customer_type_permission: permissions.edit_customer_type_permission,
      columns: [
        {
          field: 'shortCode',
          label: 'Short Code'
        },
        {
          field: 'tier',
          label: 'Tier'
        },
        {
          field: 'name',
          label: 'Name'
        },
        {
          field: 'description',
          label: 'Description'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
      currentPage: 1,
      perPage: 30,
      searchKeyword: '',
      institutionTypes: {
        page: 0,
        objects: []
      },
    }
  },
  apollo: {
    institutionTypes: {
      query: ALL_CUSTOMER_TYPES,
      variables (){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword
        }
      }
    },
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  methods: {
    ... mapActions({
      addType: 'user/addNewCustomerType',
      updateType: 'user/updateCustomerType'
    }),
    async addCustomerType(data){
      await this.addType(data).then(() => {
        this.updateCustomerTypes()
        successToast('New Customer Type added successfully')
      })
    },
    async editCustomerType(data){
      data.id = this.selected_type.publicId
      await this.updateType(data).then(resp => {
        if(resp.publicId){
          this.updateCustomerTypes()
          successToast(`${resp.name} updated successfully`)
        }

      })
    },
    selectCustomerType(row){
      this.selected_type = row
    },
    updateCustomerTypes(){
      this.$apollo.queries.institutionTypes.refetch()
    },
    searchFn(data){
      this.searchKeyword = data
    }
  }
}
</script>

<style scoped>

</style>
